import type { IconNode, LucideIcon } from 'lucide-react'
import { createLucideIcon } from 'lucide-react'

// Lucide's user-star with the star filled: the Responsible field, set apart from the
// Requester's outline star. Nudged 0.1 left so the grid test's centring holds.
export const USER_STAR_FILLED_NODES: IconNode = [
  [
    'path',
    {
      key: 'user-star-filled-0',
      d: 'M15.951 12.616C16.017 12.413 16.146 12.237 16.319 12.113C16.493 11.989 16.701 11.923 16.914 11.926C17.127 11.929 17.334 11.999 17.504 12.128C17.674 12.256 17.799 12.436 17.86 12.64L18.597 14.092C18.669 14.233 18.773 14.355 18.901 14.448C19.029 14.541 19.178 14.603 19.334 14.627L20.968 14.883C21.178 14.884 21.383 14.951 21.553 15.075C21.723 15.199 21.85 15.373 21.915 15.573C21.98 15.773 21.98 15.989 21.916 16.189C21.852 16.39 21.726 16.564 21.556 16.689L20.384 17.857C20.272 17.969 20.188 18.105 20.139 18.256C20.09 18.407 20.077 18.567 20.102 18.723L20.361 20.336C20.432 20.538 20.437 20.758 20.374 20.963C20.31 21.168 20.183 21.347 20.011 21.474C19.838 21.601 19.629 21.669 19.415 21.668C19.2 21.668 18.992 21.598 18.82 21.47L17.355 20.72C17.214 20.648 17.058 20.61 16.899 20.61C16.74 20.61 16.584 20.648 16.443 20.72L14.978 21.47C14.806 21.597 14.598 21.666 14.384 21.666C14.171 21.666 13.963 21.598 13.79 21.471C13.618 21.345 13.491 21.166 13.428 20.962C13.365 20.758 13.369 20.539 13.439 20.337L13.697 18.724C13.722 18.568 13.709 18.408 13.66 18.257C13.611 18.106 13.527 17.97 13.415 17.858L12.259 16.705C12.084 16.584 11.952 16.409 11.883 16.207C11.813 16.006 11.811 15.787 11.874 15.583C11.938 15.38 12.066 15.202 12.238 15.076C12.41 14.95 12.618 14.882 12.831 14.883L14.464 14.627C14.62 14.603 14.769 14.541 14.897 14.448C15.025 14.355 15.129 14.233 15.201 14.092Z',
      fill: 'currentColor',
    },
  ],
  [
    'path',
    {
      key: 'user-star-filled-1',
      d: 'M7.9 15L6.9 15C5.839 15 4.822 15.421 4.072 16.172C3.321 16.922 2.9 17.939 2.9 19L2.9 21',
    },
  ],
  [
    'path',
    {
      key: 'user-star-filled-2',
      d: 'M9.9 3C12.109 3 13.9 4.791 13.9 7C13.9 9.209 12.109 11 9.9 11C7.691 11 5.9 9.209 5.9 7C5.9 4.791 7.691 3 9.9 3Z',
    },
  ],
]

export const UserStarFilledIcon: LucideIcon = createLucideIcon(
  'user-star-filled',
  USER_STAR_FILLED_NODES,
)
